import { SITE_CONFIG } from '../config/siteConfig'

export type AnalyticsEvent =
  | 'whatsapp_hero_click'
  | 'whatsapp_professional_click'
  | 'whatsapp_catalog_click'
  | 'whatsapp_restaurant_click'
  | 'portfolio_project_click'
  | 'portfolio_cta_click'
  | 'whatsapp_price_click'
  | 'diagnostic_click'
  | 'whatsapp_final_click'
  | 'faq_open'
  | 'scroll_50'
  | 'scroll_90'
  | 'whatsapp_floating_click'

interface EventParameters {
  cta_location?: string
  selected_product?: string
  project_name?: string
  device_type?: 'mobile' | 'desktop'
}

export function createWhatsAppUrl(message: string) {
  return `https://wa.me/${SITE_CONFIG.whatsappNumber}?text=${encodeURIComponent(message)}`
}

export function getDeviceType(): 'mobile' | 'desktop' {
  return window.innerWidth < 768 ? 'mobile' : 'desktop'
}

export function trackEvent(
  event: AnalyticsEvent,
  parameters: EventParameters = {},
) {
  const payload = { ...parameters, device_type: getDeviceType() }
  const fbq = (window as Window & { fbq?: (...args: unknown[]) => void }).fbq
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag

  if (typeof fbq === 'function') {
    fbq('trackCustom', event, payload)
  }

  if (typeof gtag === 'function' && SITE_CONFIG.analytics.ga4MeasurementId) {
    gtag('event', event, payload)
  }
}
